export interface AvatarConfig {
  bgColor: string;
  emoji: string;
  shape: 'circle' | 'rounded' | 'hex';
  borderColor: string;
  profilePhoto?: string; // base64 compressed JPEG
}

export const DEFAULT_AVATAR: AvatarConfig = {
  bgColor: '#7c3aed',
  emoji: '\ud83d\udc64',
  shape: 'circle',
  borderColor: '#ffffff15',
};

export interface StabeonUser {
  nullifierHash: string;
  walletAddress?: string; // World App wallet address — used for push notifications
  nickname: string;
  avatar: AvatarConfig;
  lat: number | null;
  lng: number | null;
  locationPrecision: 'exact' | 'approximate' | 'hidden';
  activity: string;
  activityCategory: ActivityCategory;
  isMoving: boolean;
  heading: number;
  isOnline: boolean;
  lastSeen: number;
  visibilityRadius: number | null;
  onboarded?: boolean;
  referredBy?: string;
  
  // Gamification fields
  badges: string[]; // Array of badge IDs earned
  streak: number;   // Current streak of consecutive days with activity
  lastActivityDate: string | null; // Last date activity was recorded (YYYY-MM-DD)
  totalActivityDays: number; // Total days with any activity
  level: number;    // Current level (1-100)
  experience: number; // Current experience points
  recoveryCode?: string; // 8-char code for cross-device login
  interests?: string[]; // User-selected interest tags for event matchmaking
  bio?: string;
  city?: string;
  country?: string;

  // Matchmaking fields
  lookingFor?: import('./match').LookingFor;
  matchOnboarded?: boolean;   // completed match-specific onboarding
  age?: number;
  gender?: string;
}

export const INTEREST_TAGS = [
  'music', 'sports', 'tech', 'food', 'art', 'outdoor', 'travel', 'gaming',
  'fitness', 'movies', 'books', 'photography', 'dancing', 'coding', 'yoga',
  'coffee', 'hiking', 'concerts', 'networking', 'comedy',
];

export type ActivityCategory =
  | 'work' | 'social' | 'transit' | 'food'
  | 'outdoor' | 'fitness' | 'gaming' | 'study'
  | 'home' | 'other';

export const ACTIVITY_CATEGORIES: { key: ActivityCategory; label: string; emoji: string }[] = [
  { key: 'work',    label: 'Working',   emoji: '\ud83d\udcbc' },
  { key: 'social',  label: 'Social',    emoji: '\ud83c\udf89' },
  { key: 'transit', label: 'Commuting', emoji: '\ud83d\ude8c' },
  { key: 'food',    label: 'Eating',    emoji: '\ud83c\udf5c' },
  { key: 'outdoor', label: 'Outdoors',  emoji: '\ud83c\udf3f' },
  { key: 'fitness', label: 'Fitness',   emoji: '\ud83c\udfc3' },
  { key: 'gaming',  label: 'Gaming',    emoji: '\ud83c\udfae' },
  { key: 'study',   label: 'Studying',  emoji: '\ud83d\udcda' },
  { key: 'home',    label: 'At home',   emoji: '\ud83c\udfe0' },
  { key: 'other',   label: 'Other',     emoji: '\u2728' },
];
